import type { PostsList, PostsListResult } from 'lib/queries/blog';
import React, { useRef } from 'react';
import { Wrap } from '@leafwell/components';
import CardsGrid, { CardsGridProps } from './cards-grid';
import Pagination from './pagination';

const Archive: React.FC<
  PostsListResult<PostsList> & {
    title?: string;
    subtitle?: string;
    variant?: CardsGridProps['variant'];
    className?: string;
  }
> = ({
  posts,
  pagination,
  title,
  subtitle,
  variant = 'medium',
  className = '',
}) => {
  const archiveEl = useRef(null);

  return (
    <Wrap className={className} size="large" ref={archiveEl}>
      <CardsGrid
        items={posts}
        title={title}
        subtitle={subtitle}
        variant={variant}
      />
      <Pagination
        limit={pagination.limit}
        offset={pagination.offset}
        total={pagination.total}
        className={'col-span-full justify-self-center md:mt-6'}
      />
    </Wrap>
  );
};

export default Archive;
